var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.007.857H.634v24.026h23.373z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.31 2.859c5.386 0 9.749 4.485 9.749 10.01 0 5.527-4.363 10.012-9.748 10.012-5.376 0-9.73-4.485-9.73-10.011 0-5.526 4.354-10.011 9.73-10.011zm.01 2.002c-4.304 0-7.79 3.584-7.79 8.009 0 4.425 3.486 8.008 7.79 8.008 4.305 0 7.791-3.583 7.791-8.008 0-4.425-3.486-8.009-7.79-8.009zm.487 3.003v5.256l4.383 2.673-.73 1.231-5.114-3.153V7.864h1.461z",
    fill: "#F90"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsClock);
export default __webpack_public_path__ + "static/media/icons-clock.724dfb868d0f274edf01640bb30d56a1.svg";
export { ForwardRef as ReactComponent };